import CardActionsRoot, { Props } from './CardActions'

export default function CardActions(props: Props) {
  return <CardActionsRoot {...props} />
}
